import { Eyebrow, ProjectCard, Reveal, Section } from "@/ds";
import { experience, experienceSection } from "@/content/portfolio";

export function Experience() {
  return (
    <Section
      id="work"
      className="scroll-mt-[var(--header-h)]"
      eyebrow={<Eyebrow>{experienceSection.eyebrow}</Eyebrow>}
      title={experienceSection.headline}
      titleClassName="max-w-[24ch]"
      headerClassName="mb-7"
    >
      {/* The reference used auto-fit minmax(340px, 1fr), tuned for the two cards
          it showed. With four entries that resolves to 3-up plus a lone fourth,
          so the columns are explicit instead — 2x2 at desktop, stacked below md.
          (The old bare minmax also could not shrink under 340px and overflowed a
          375px viewport by ~21px; a single column cannot.) */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
        {experience.map((item, i) => (
          <Reveal key={item.index} index={i}>
            <ProjectCard
              index={item.index}
              title={item.title}
              src={item.src}
              alt={item.alt}
              meta={item.meta}
              href={item.href}
            />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
